var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 340,
    viewBox: "0 0 344 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M277.134 127.082C297.336 133.658 317.327 127.831 321.828 114.091C326.298 100.339 313.571 83.856 293.379 77.2478C273.188 70.6395 253.186 76.4983 248.685 90.2387C244.205 104.022 256.931 120.506 277.134 127.082Z",
    fill: "url(#paint0_linear_14_3612)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M323.603 108.607L321.828 114.091C326.298 100.339 313.571 83.856 293.379 77.2478C273.188 70.6395 253.186 76.4983 248.685 90.2388L250.459 84.7553C254.929 71.0038 274.951 65.1883 295.154 71.7643C315.356 78.3403 328.104 94.8669 323.603 108.607Z",
    fill: "url(#paint1_linear_14_3612)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M277.644 125.49C295.836 131.412 313.816 126.193 317.852 113.807C321.888 101.421 310.43 86.599 292.249 80.6451C274.057 74.7233 256.078 79.9425 252.041 92.3284C248.026 104.758 259.485 119.58 277.644 125.49Z",
    fill: "url(#paint2_linear_14_3612)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M277.954 124.588C295.92 130.432 313.693 125.394 318.007 113.356C317.952 113.517 317.94 113.657 317.884 113.818C313.848 126.204 295.825 131.445 277.676 125.502C259.485 119.58 248.037 104.726 252.073 92.3396C252.129 92.1784 252.173 92.0494 252.228 91.8881C248.613 104.202 259.988 118.743 277.954 124.588Z",
    fill: "#A86314"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M266.831 221.245C267.945 242.466 272.709 259.459 277.489 259.19C282.257 258.952 285.238 241.553 284.124 220.333C283.01 199.112 278.246 182.118 273.467 182.388C268.687 182.658 265.706 200.057 266.831 221.245Z",
    fill: "url(#paint3_linear_14_3612)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M267.198 221.227C268.18 240.311 272.485 255.597 276.779 255.377C281.072 255.157 283.747 239.491 282.765 220.407C281.783 201.323 277.477 186.037 273.184 186.257C268.89 186.477 266.215 202.142 267.198 221.227Z",
    fill: "url(#paint4_linear_14_3612)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M267.672 221.209C268.636 239.927 272.792 255.018 277.005 255.347C276.93 255.357 276.854 255.367 276.779 255.377C272.485 255.597 268.18 240.311 267.198 221.227C266.215 202.142 268.89 186.477 273.184 186.257C273.259 186.247 273.356 186.28 273.432 186.27C269.262 187.073 266.708 202.492 267.672 221.209Z",
    fill: "#A86314"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M282.257 258.952L277.445 259.211C282.214 258.973 285.195 241.575 284.081 220.354C282.967 199.134 278.203 182.14 273.423 182.409L278.235 182.151C283.003 181.913 287.768 198.907 288.893 220.095C290.007 241.316 287.025 258.715 282.257 258.952Z",
    fill: "url(#paint5_linear_14_3612)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111.466 50.984C132.558 53.3949 150.108 51.5255 150.657 46.775C151.207 42.0246 134.524 36.2242 113.432 33.8133C92.3401 31.4024 74.7898 33.2719 74.2403 38.0224C73.7019 42.7405 90.3742 48.5731 111.466 50.984Z",
    fill: "url(#paint6_linear_14_3612)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M111.523 50.6071C130.493 52.7941 146.295 51.0814 146.786 46.8157C147.277 42.55 132.271 37.3254 113.301 35.1385C94.3318 32.9515 78.5299 34.6642 78.0386 38.9299C77.5151 43.1846 92.5215 48.4091 111.523 50.6071Z",
    fill: "url(#paint7_linear_14_3612)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M111.582 50.1224C130.206 52.2631 145.76 50.6453 146.799 46.5678C146.809 46.6433 146.819 46.7189 146.786 46.8157C146.295 51.0814 130.493 52.7941 111.523 50.6071C92.5538 48.4201 77.5474 43.1956 78.0386 38.9299C78.0285 38.8543 78.0617 38.7576 78.0839 38.6931C78.1539 42.8991 92.9244 47.9706 111.582 50.1224Z",
    fill: "#A86314"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M151.218 41.9923L150.658 46.775C151.207 42.0246 134.524 36.2242 113.432 33.8133C92.3401 31.4024 74.7899 33.2719 74.2403 38.0223L74.8009 33.2396C75.3504 28.4892 92.9007 26.6197 113.992 29.0306C135.084 31.4416 151.735 37.2308 151.218 41.9923Z",
    fill: "url(#paint8_linear_14_3612)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M173.782 250.116C157.218 263.392 152.847 285.469 164.022 299.437C175.208 313.372 197.697 313.92 214.272 300.611C230.835 287.335 235.207 265.258 224.032 251.29C212.845 237.355 190.346 236.84 173.782 250.116Z",
    fill: "url(#paint9_linear_14_3612)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M175.83 252.658C160.906 264.622 157.007 284.482 167.041 297.049C177.119 309.594 197.354 310.088 212.278 298.124C227.201 286.159 231.1 266.299 221.066 253.733C210.957 241.177 190.721 240.682 175.83 252.658Z",
    fill: "url(#paint10_linear_14_3612)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M167.669 303.934L164.054 299.448C175.241 313.383 197.729 313.931 214.304 300.622C230.868 287.346 235.239 265.269 224.064 251.301L227.679 255.787C238.866 269.723 234.494 291.8 217.919 305.108C201.345 318.417 178.845 317.902 167.669 303.934Z",
    fill: "url(#paint11_linear_14_3612)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M176.405 253.396C161.634 265.233 157.651 284.812 167.351 297.407C167.244 297.298 167.148 297.157 167.041 297.049C156.964 284.504 160.906 264.622 175.83 252.658C190.753 240.693 210.989 241.188 221.066 253.733C221.162 253.874 221.269 253.983 221.365 254.124C211.165 241.933 191.177 241.56 176.405 253.396Z",
    fill: "#7E470D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M173.036 107.599C194.058 110.527 210.598 116.746 209.94 121.496C209.283 126.245 191.704 127.672 170.65 124.734C149.627 121.806 133.099 115.554 133.745 110.837C134.402 106.087 151.992 104.628 173.036 107.599Z",
    fill: "url(#paint12_linear_14_3612)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M172.978 107.976C191.901 110.615 206.774 116.227 206.175 120.492C205.576 124.756 189.735 126.059 170.812 123.419C151.89 120.78 137.017 115.168 137.616 110.904C138.226 106.607 154.067 105.304 172.978 107.976Z",
    fill: "url(#paint13_linear_14_3612)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M172.931 108.428C191.509 111.021 206.158 116.448 206.141 120.696C206.163 120.632 206.196 120.535 206.186 120.459C206.785 116.195 191.912 110.583 172.989 107.944C154.067 105.304 138.226 106.607 137.627 110.871C137.604 110.936 137.604 111.044 137.614 111.119C138.761 107.043 154.353 105.835 172.931 108.428Z",
    fill: "#7E470D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M209.251 126.234L209.908 121.485C209.251 126.234 191.672 127.661 170.617 124.723C149.595 121.795 133.067 115.543 133.713 110.826L133.055 115.575C132.398 120.325 148.905 126.533 169.96 129.472C191.015 132.411 208.593 130.984 209.251 126.234Z",
    fill: "url(#paint14_linear_14_3612)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_3612",
    x1: 293.616,
    y1: 76.537,
    x2: 275.817,
    y2: 131.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3912F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14_3612",
    x1: 330.432,
    y1: 100.087,
    x2: 263.317,
    y2: 78.2072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1216,
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2011,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2776,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3693,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6514,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A86314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14_3612",
    x1: 314.3,
    y1: 11.6611,
    x2: 271.899,
    y2: 143.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459,
    stopColor: "#FFDF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE7A22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14_3612",
    x1: 284.353,
    y1: 220.338,
    x2: 265.412,
    y2: 221.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3912F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14_3612",
    x1: 316.985,
    y1: 218.638,
    x2: 256.724,
    y2: 221.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459,
    stopColor: "#FFDF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE7A22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14_3612",
    x1: 284.284,
    y1: 260.842,
    x2: 279.934,
    y2: 177.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1216,
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2011,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2776,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3693,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6514,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A86314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14_3612",
    x1: 113.467,
    y1: 33.5352,
    x2: 111.307,
    y2: 52.3782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3912F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14_3612",
    x1: 113.649,
    y1: 23.6386,
    x2: 111.742,
    y2: 52.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9A83D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14_3612",
    x1: 153.401,
    y1: 40.3035,
    x2: 70.3422,
    y2: 30.7817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1216,
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2011,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2776,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3693,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6514,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A86314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14_3612",
    x1: 185.118,
    y1: 264.256,
    x2: 211.371,
    y2: 296.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_14_3612",
    x1: 230.435,
    y1: 320.754,
    x2: 176.513,
    y2: 253.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9A83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C5110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_14_3612",
    x1: 174.516,
    y1: 315.486,
    x2: 233.44,
    y2: 268.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1216,
    stopColor: "#E9A83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2191,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2776,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3693,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3821,
    stopColor: "#E6B248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3992,
    stopColor: "#CB9235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4169,
    stopColor: "#B57925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4354,
    stopColor: "#A6681B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4552,
    stopColor: "#9D5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5355,
    stopColor: "#9F5F15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6015,
    stopColor: "#AD6D1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#C48429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7451,
    stopColor: "#E4A43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7956,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C5110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_14_3612",
    x1: 170.614,
    y1: 128.513,
    x2: 173.759,
    y2: 96.7544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_14_3612",
    x1: 177.371,
    y1: 76.5646,
    x2: 169.869,
    y2: 130.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9A83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C5110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_14_3612",
    x1: 210.961,
    y1: 128.414,
    x2: 128.164,
    y2: 116.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1216,
    stopColor: "#E9A83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2191,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2776,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3693,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3821,
    stopColor: "#E6B248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3992,
    stopColor: "#CB9235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4169,
    stopColor: "#B57925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4354,
    stopColor: "#A6681B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4552,
    stopColor: "#9D5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5355,
    stopColor: "#9F5F15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6015,
    stopColor: "#AD6D1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#C48429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7451,
    stopColor: "#E4A43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7956,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C5110"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin3);
export default __webpack_public_path__ + "static/media/coin3.6a895e0107c5c58e8c3084c03324ee91.svg";
export { ForwardRef as ReactComponent };